import React, { useState, useEffect } from "react";
import axios from "axios";
import Loading from "../pages/Helper/loading";

// Define the list of allowed IPs and IP ranges

const allowedStageIps = [
];

const allowedIps = [
];

const allowedIpRanges = [
];


// Function to check if an IP is within any of the allowed ranges
const isIpInRange = (ip, ranges) => {
  const ipToNumber = (ip) =>
    ip.split(".").reduce((acc, octet) => acc * 256 + parseInt(octet, 10), 0);
  const ipNum = ipToNumber(ip);

  return ranges.some(({ start, end }) => {
    const startNum = ipToNumber(start);
    const endNum = ipToNumber(end);
    return ipNum >= startNum && ipNum <= endNum;
  });
};

export default function RouteGuard({ children }) {
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    //  withRestrictedAccess();
  }, []);

  const withRestrictedAccess = async () => {
    try {
      const result = await axios.get("https://api.ipify.org/?format=json");
      const userIp = result.data.ip;
      console.log(userIp);

      let isAllowed = false;
      if (process.env.REACT_APP_ENV === "stage") {
        // isAllowed = allowedStageIps.includes(userIp);
        isAllowed = true;
      } else {
        isAllowed =
          allowedIps.includes(userIp) || isIpInRange(userIp, allowedIpRanges);
      }

      if (!isAllowed) {
        console.log("not allowed");
        window.location.href = "/forbidden";
      } else {
        setIsAllowed(true);
      }
    } catch (error) {
      console.error("Error fetching IP address:", error);
      window.location.href = "/error";
    }
  };

  return <div>{isAllowed ? children : <Loading />}</div>;
}
